import CitySEOHead from "@/components/feature/CitySEOHead";
import KennesawHeroSection from "./components/HeroSection";
import KennesawStickyNav from "./components/StickyNav";
import KennesawProcessingTimeSection from "./components/ProcessingTimeSection";
import KennesawServicesSection from "./components/ServicesSection";
import KennesawLocalAreaSection from "./components/LocalAreaSection";
import KennesawTestimonialsSection from "./components/TestimonialsSection";
import KennesawAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import KennesawComparisonSection from "./components/ComparisonSection";
import KennesawMistakesSection from "./components/MistakesSection";
import KennesawHowItWorksSection from "./components/HowItWorksSection";
import KennesawFAQSection, { faqs } from "./components/FAQSection";
import KennesawHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import KennesawFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const kennesawServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function KennesawPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Kennesaw"
        state="Georgia"
        stateAbbr="GA"
        route="/cities/kennesaw"
        title="Emergency Passport Kennesaw, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Kennesaw, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Cobb County and northwest Atlanta metro travelers. Get your emergency passport fast!"
        geoPlacename="Kennesaw, Georgia"
        geoPosition="34.0234;-84.6155"
        faqs={faqs}
        servicesSchema={kennesawServices}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
        keywords="expedited passport, emergency passport, Kennesaw passport, same day passport Kennesaw, fast passport Georgia, Cobb County passport"
      />
      <KennesawHeroSection />
      <KennesawStickyNav />
      <KennesawProcessingTimeSection />
      <KennesawServicesSection />
      <KennesawLocalAreaSection />
      <KennesawTestimonialsSection />
      <KennesawAcceptanceFacilitiesSection />
      <KennesawComparisonSection />
      <KennesawMistakesSection />
      <KennesawHowItWorksSection />
      <KennesawFAQSection />
      <KennesawHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/kennesaw" state="GA" />
      <KennesawFinalCTA />
    </div>
  );
}